import React, { useEffect, useState } from "react"

// NOTE: Two-pass rendering strategy is the supported way
// https://github.com/facebook/react/issues/23381#issuecomment-1079494600
export const ClientOnly: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    const [canRender, setCanRender] = useState(false)
    useEffect(() => {
        setCanRender(true)
    }, [])
    return <>{canRender ? children : undefined}</>
}
